import React, { useState } from 'react';
import organizationsService from '../../services/organizationsService';

// ── Create ───────────────────────────────────────────────────────────────────

export function CreateOrganization({ onClose, onCreated }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    if (!name.trim()) return;
    setBusy(true);
    setError('');
    try {
      await organizationsService.createOrganization({ name: name.trim() });
      await onCreated();
      onClose();
    } catch (e) {
      // The server returns a field-keyed error map; the slug one is the only
      // failure a user can actually act on ("that name is taken").
      const errs = e?.response?.data?.errors;
      setError(errs?.slug ? `That name is taken (${errs.slug.join(', ')})` : 'Could not create the organization.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="org-modal-backdrop" onClick={onClose}>
      <div className="org-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="org-modal-title">New organization</h3>
        <label className="org-field">
          <span className="org-field-label">Name</span>
          <input
            className="org-input"
            value={name}
            autoFocus
            placeholder="Acme Inc"
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
        </label>
        <p className="org-hint">
          You become its owner. Teams stay exactly where they are until you attach them.
        </p>
        {error && <p className="org-error">{error}</p>}
        <div className="org-modal-actions">
          <button type="button" className="org-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="org-btn org-btn--primary"
            disabled={busy || !name.trim()}
            onClick={submit}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
}
